var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.adaptiveStart)?_c('div'):_vm._e(),_c('div',{staticClass:"odr-block-wrap",class:{
             'odr-block-wrap_transparent': _vm.asTransparent,
             'odr-block-wrap_inline': _vm.innerWrap || _vm.adaptive,
             'odr-block-wrap_highlight': _vm.highlight,
         },style:(("\n            width: " + _vm.width + "% !important;\n         "))},[_vm._t("default")],2),(_vm.adaptiveEnd)?_c('div'):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }